/* RESPONSIBLE TEAM: team-reporting */
import Transform from '@ember-data/serializer/transform';
import { isObject } from 'underscore';

export default class HashTransform extends Transform {
  serialize(deserialized: Record<string, any>, opts = {}): Record<string, any> {
    let excludeKeys: string[] = (opts as { excludeKeys?: string[] })?.excludeKeys ?? [];

    let result = this.convertCase(
      this.camelToSnakeCase,
      this.excludeKeys(deserialized, excludeKeys),
      {},
    );

    let excludedObjs = excludeKeys.reduce(
      (acc: Record<string, any>, key: string) => {
        if (excludeKeys.includes(key) && deserialized[key]) {
          acc[key] = deserialized[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );

    return {
      ...result,
      ...excludedObjs,
    };
  }

  deserialize(serialized: Record<string, any>, opts = {}): Record<string, any> {
    let excludeKeys: string[] = (opts as { excludeKeys?: string[] })?.excludeKeys ?? []; // camel case

    let camelToSnakeCaseObj = excludeKeys.reduce(
      (acc, key) => {
        acc[key] = this.camelToSnakeCase(key);
        return acc;
      },
      {} as Record<string, string>,
    );

    let excludedSnakeCasedKeys = Object.values(camelToSnakeCaseObj);

    let excludedObjs = excludedSnakeCasedKeys.reduce(
      (acc: Record<string, any>, key: string) => {
        if (excludedSnakeCasedKeys.includes(key) && serialized[key]) {
          acc[key] = serialized[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );

    let result = this.convertCase(
      this.snakeToCamelCase,
      this.excludeKeys(serialized, Object.values(camelToSnakeCaseObj)),
      {},
    );

    return {
      ...result,
      ...excludedObjs,
    };
  }

  private excludeKeys(obj: Record<string, any>, excludeKeys: string[]): Record<string, any> {
    return Object.keys(obj).reduce(
      (acc, key) => {
        if (!excludeKeys.includes(key)) {
          acc[key] = obj[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );
  }

  private convertCase(
    fn: (key: string) => string,
    obj: Record<string, any>,
    caseObject: Record<string, any> = {},
  ) {
    Object.keys(obj).forEach((key: string) => {
      let value = obj[key];
      if (isObject(value) && !Array.isArray(value)) {
        // isObject returns true for array
        caseObject[fn(key)] = this.convertCase(fn, value, {});
      } else {
        let newKey = fn(key);
        caseObject[newKey] = value;
      }
    });
    return caseObject;
  }

  private camelToSnakeCase(key: string): string {
    return key.replace(/([A-Z])/g, '_$1').toLowerCase();
  }

  private snakeToCamelCase(key: string): string {
    return key.replace(/_([a-z])/g, (_, p1) => p1.toUpperCase());
  }
}
